// Delphi's glyph in the Hardaway Constellation.
//
// House style (same family as Prism and Catalyst): one simple geometric mark,
// line-art, no gradients, and a palette limited to gold / white / blue-grey so
// it reads on a navy badge. Prism owns the triangle and Catalyst the spark, so
// Delphi is the oracle's lens — the thing that sees what's coming, which is what
// this app does with staffing and revenue.
//
// Seat it in a navy rounded square on light surfaces; place it bare on navy.
import React from "react";

export default function DelphiMark({ size = 32, className, title = "Delphi" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      {/* the lens — gold line-art, matching Prism's weight */}
      <path
        d="M6 50 C26 18, 74 18, 94 50 C74 82, 26 82, 6 50 Z"
        fill="none"
        stroke="#dfab01"
        strokeWidth="6"
        strokeLinejoin="round"
      />
      {/* pupil + glint */}
      <circle cx="50" cy="50" r="13.5" fill="#7a85a5" />
      <circle cx="55.5" cy="44" r="3.8" fill="#ffffff" />
    </svg>
  );
}
